import { render, staticRenderFns } from "./create-check.vue?vue&type=template&id=4ae6f660&scoped=true&"
import script from "./create-check.vue?vue&type=script&lang=js&"
export * from "./create-check.vue?vue&type=script&lang=js&"
import style0 from "./create-check.vue?vue&type=style&index=0&id=4ae6f660&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6f660",
  null
  
)

export default component.exports